// Compact gold: whole thousands as `Nk`, values ≥1M as `N[.N]M`. This is the
// single ≥1M behavior chosen for FE-10 — team value and treasury can exceed 1M,
// and every surface now renders the M-suffix rather than a full comma-grouped
// number. See format.test.ts for the pinned boundary cases.
export function formatGold(amount: number): string {
  if (Math.abs(amount) >= 1_000_000) {
    const m = amount / 1_000_000
    return `${Number.isInteger(m) ? m : m.toFixed(1)}M`
  }
  return `${amount / 1000}k`
}

// Full comma-grouped gold, e.g. 1_234_000 => "1,234,000". Used where a page
// wants the exact figure rather than the compact `formatGold` form.
export function formatFullGold(amount: number): string {
  return new Intl.NumberFormat("en-US").format(amount)
}

// A player stat rendered as a dice target: AG/PA read as roll-or-higher ("3+"),
// other stats print plainly, null renders as an en-dash placeholder.
export function formatTargetNumber(value: number | null, stat: string): string {
  if (value === null) return "–"
  if (stat === "AG" || stat === "PA") return `${value}+`
  return String(value)
}

// A nullable target-number stat as `N+`, with an em-dash placeholder for null.
export function withPlus(value: number | null): string {
  if (value === null) return "—"
  return `${value}+`
}

export function positionClass(rank: number): string {
  if (rank === 1) return "text-[var(--accent)]"
  if (rank === 2) return "text-[oklch(0.70_0.02_250)]"
  if (rank === 3) return "text-[oklch(0.60_0.10_55)]"
  return "text-muted-foreground"
}
